module.exports = __webpack_public_path__ + "img/star-half.c80fa1ce.svg";